import React from 'react';
import './FeatureCard.css'

const FeatureCard = (props) => {
    return ( 
        <div className='FeatureCard'>
            <img src={props.FCardImg} alt="" />
            <p className='FCardTitle'>{props.FCardTitle}</p>
            <p className='FCardSub'>{props.FCardSub}</p>
        </div>
     );
}
 
export default FeatureCard;